var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading)?_c('font-awesome-icon',{staticClass:"text-hint align-self-center",attrs:{"icon":"spinner-third","spin":"","size":"lg"}}):_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.src}})}
var staticRenderFns = []

export { render, staticRenderFns }